import React from 'react';

import { App as AppCore } from 'js/components/system/App/App';
import { BottomStickyElements } from '@interlayer/js/app/components/system/BottomStickyElements';

import { APP_CONTEXT_VALUE, AppContext } from './buzz/context';
import { useBeforeInitHooks } from './buzz/hooks/useBeforeInitHooks';

export const App = ({ children }) => {
    useBeforeInitHooks();

    return (
        <AppContext.Provider value={APP_CONTEXT_VALUE}>
            <AppCore>
                {children}
                <BottomStickyElements />
            </AppCore>
        </AppContext.Provider>
    );
};

